
export enum EquipmentSizeCd {
	OK_EVEN_IN_A_GEOGRAPHIC_AREA_OTHERWISE_RESTRICTED_TO_PU = 'OKEvenInAGeographicAreaOtherwiseRestrictedToPU',
	PUP_OR_SMALLER_REQUIRED = 'PupOrSmallerRequired',
	STRAIGHT_TRUCK_BOX_TRUCK_REQUIRED = 'StraightTruckBoxTruckRequired'}

